import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	inviteAndAssign: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	inviteAndAssign: {
		id: 'invite-and-assign.common.invite-and-assign',
		defaultMessage: 'Invite and assign',
		description: 'Helper text on invite and assign option',
	},
});
export default messages;
